"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _GenericStore2 = _interopRequireDefault(require("./GenericStore"));

var _DataStore = _interopRequireWildcard(require("./DataStore2"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ContentStore = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(ContentStore, _GenericStore);

  var _super = _createSuper(ContentStore);

  function ContentStore() {
    var _this;

    (0, _classCallCheck2["default"])(this, ContentStore);
    _this = _super.call(this);
    _this.tempContent = {};
    return _this;
  }

  (0, _createClass2["default"])(ContentStore, [{
    key: "contentWithIdIsAvailable",
    value: function contentWithIdIsAvailable(id) {
      if (id) {
        var singleIds = id.split('!');
        var lastId = singleIds[singleIds.length - 1];
        var contentToCheck = this.state.content[lastId];

        var nonEmptyCheck = function nonEmptyCheck(check) {
          return (0, _typeof2["default"])(check) === 'object' && (0, _keys["default"])(check).length > 0;
        };

        return Boolean(contentToCheck) && nonEmptyCheck(contentToCheck);
      }

      return false;
    }
  }, {
    key: "addEntity",
    value: function addEntity(entity) {
      /*
      const updatedState = {}
      updatedState.content = Object.assign({}, this.state.content, {[entity.id]: entity})
      super.setValues(updatedState)
      */
      this.tempContent[entity.id] = entity;
    }
  }, {
    key: "setUpdateValue",
    value: function setUpdateValue() {
      // TODO find a better solution
      var updateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, updateValue + 1);
    }
  }, {
    key: "finishedAddingEntities",
    value: function finishedAddingEntities() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ContentStore.prototype), "setValues", this).call(this, {
        content: this.tempContent
      }, this.setUpdateValue());
    }
  }, {
    key: "removeEntity",
    value: function removeEntity(id) {
      var updatedState = {};
      updatedState.content = _objectSpread({}, this.state.content);
      delete updatedState.content[id];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ContentStore.prototype), "setValues", this).call(this, updatedState);
    }
  }, {
    key: "initialState",
    value: function initialState() {
      return {
        content: {}
      };
    }
  }]);
  return ContentStore;
}(_GenericStore2["default"]);

var contentStore = new ContentStore();
var _default = contentStore;
exports["default"] = _default;